// CommandMenu.jsx
import React from 'react';
import { Command } from 'cmdk';
import "./Index.scss";
import { useSearchKeywordsData } from '../../utils/constants/searchKeywords';

const CommandMenu = ({ 
  placeholder = 'Type a command...', 
  label = 'Command Menu', 
  onSelect,
  openSearch,
  setOpenSearch
}) => {
  const items = useSearchKeywordsData();

  return (
    <>
      {openSearch && <div className="cmdk-overlay" onClick={() => setOpenSearch(false)} />}
      <Command.Dialog 
        open={openSearch} 
        onOpenChange={setOpenSearch} 
        label={label}
        className="cmdk-dialog"
      >
        <div className="cmdk-input-wrapper">
          <svg 
            className="cmdk-search-icon"
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="#666" 
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <Command.Input placeholder={placeholder} />
          <button 
            className="cmdk-close-btn"
            onClick={() => setOpenSearch(false)}
            aria-label="Close"
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="#666" 
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <Command.List>
          <Command.Empty>No results found.</Command.Empty>
          {items.map((group, groupIdx) => (
            <Command.Group key={group.heading || groupIdx} heading={group.heading}>
              {group.items.map((item) => (
                <Command.Item
                  key={item.value}
                  value={item.value}
                  onSelect={() => {
                    onSelect?.(item.value);
                    setOpenSearch(false);
                  }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  {item.icon && (
                    <img
                      src={item.icon}
                      alt={`${item.label} icon`}
                      style={{ width: '16px', height: '16px', marginRight: '8px' }}
                    />
                  )}
                  {item.label}
                </Command.Item>
              ))}
              {groupIdx < items.length - 1 && <Command.Separator />}
            </Command.Group>
          ))}
        </Command.List>
      </Command.Dialog>
    </>
  );
};

export default CommandMenu;